
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.25 18.75H2.393c-.908 0-1.643-.895-1.643-2v-14c0-1.105.735-2 1.643-2H13.07c.908 0 1.643.895 1.643 2v4","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.75 9.75l-5 5.5-2-1.895","stroke":"#3092d0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.82 10.017a4.301 4.301 0 00-1.512-.303 4.5 4.5 0 104.066 6.313","stroke":"#404040","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.5 6H10"}})])
          )
        }
      }
    